import React from 'react'

import profImg from "../../../../../assets/Images/TestImg/profileImage.png"
// import profImg from "../../../.."

const TreeCustomElement = ({ nodeDatum }) => {

    return (
        <g style={{ width: "10rem", height: "10rem" }}>
            <circle r={20} className='nodeCircle' z={2} fill={nodeDatum.nodeColor || "gray"} stroke={nodeDatum.nodeColor || "gray"} strokeWidth={2} />
            <g className='hoverNodeElement' x={85} y={200} z={0}>
                <g filter="url(#filter0_d_427_4827)" z={9999}>
                    <rect x="28" y="-50" width="249" height="70" z={10} rx="10" fill="white" />
                    <rect x="28" y="-50" width="248" height="69" z={10} rx="9.5" pointsAtZ={20} stroke="#DDDDDD" />
                </g>
                <text x="100" y="-26" z={10} font-size="14px" className='hoverCardProfileName'>{nodeDatum.name}</text>
                <text x="100" y="-10" fill="gray" color='gray' className='svgRoleText'>{nodeDatum.role}</text>
                <defs>
                    <clipPath id="circleClip">
                        <circle cx="65" cy="-15" stroke='none' r="24.5" />
                    </clipPath>
                </defs>
                <image
                    x="26"
                    y="-40"
                    width="80"
                    height="70"
                    href={profImg}
                    clipPath="url(#circleClip)"
                />



            </g>
     


        </g>





    )

}



export default TreeCustomElement